// extracted by mini-css-extract-plugin
export var actions = "_lw-g";
export var benefitCard = "_lw-b";
export var benefitIcon = "_lw-d";
export var benefitLabel = "_lw-f";
export var benefits = "_lw-a";
export var benefitsSection = "_lw-8";
export var bodyText = "_lw-7";
export var closeButton = "_lw-2";
export var content = "_lw-3";
export var eyebrow = "_lw-4";
export var heading = "_lw-5";
export var image = "_lw-i";
export var imagePanel = "_lw-h";
export var modal = "_lw-0";
export var offerCard = "_lw-c";
export var offerIcon = "_lw-e";
export var sectionLabel = "_lw-9";
export var shell = "_lw-1";
export var title = "_lw-6";